// Dark-first marquee. Yellow band uses BLACK text for WCAG AAA contrast.
import React from "react";

const Marquee = ({ items = [], testId = "marquee" }) => {
  const doubled = [...items, ...items];
  return (
    <div data-testid={testId} className="w-full bg-[#FFC600] text-black overflow-hidden">
      <div className="k-marquee flex whitespace-nowrap py-4 lg:py-5">
        {doubled.map((it, idx) => (
          <span key={`${idx}-${it}`} className="text-sm sm:text-base font-bold uppercase tracking-[0.18em] mx-8">
            <span className="mr-8">{it}</span>
            <span className="opacity-70">★</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
